import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import { useSnackbar } from "notistack";
import { Container, Row, Col, Button, Card, Badge, Tooltip } from "reactstrap";
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import API from "../../../redux/actions/API";
import {
  DOG_LICENSE_DETAILS,
  UPDATE_LICENSE_STATUS,
  REFUND_PAYMENT,
} from "../../../constants/ApiPaths";

import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import Swal from "sweetalert2";

import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { JSONParser } from "../../../functions/Helper";
import AgencyPreviewform from "../../Agency/Customer/AgencyPreviewform";
import moment from "moment";
import { Info } from "../../common/Info";
import ReuploadFormValue from "../../User/License/ReuploadFormValue";
import { useSelector } from "react-redux";
// const initailValue = {
//   validFromDate: "",
//   validToDate: "",
//   dogLicenseNumber: "",
// };
function Userviewlicense() {
  const { licensePlanId, dogLicenseId } = useParams();
  const [licenseDetails, setlicenseDetails] = useState({});
  // const [Reupload, setReupload] = useState(initailValue);
  const [loading, setloading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  // const [DeleverSpinner, setDeleverSpinner] = useState(false);
  const [isEditable, setisEditable] = useState(true);
  const DeleteAgency = useSelector((state) => state.Agencydelete);
  const [isPdfDownload, setIsPdfDownload] = useState(false);
  const {
    licensePlanDetails,
    categoryDetails,
    licenseComments,
    licenseStatus,
    paymentDetails,
    licenseRequiredDocDetails,
    dogId,
  } = licenseDetails;
  const paymentData = JSONParser(paymentDetails, []);
  const paymaentid = paymentData[0];
  const licensePlanData = JSONParser(licensePlanDetails, []);
  const categoryData = JSONParser(categoryDetails, []);
  const document1 = JSONParser(licenseRequiredDocDetails, []);

  const Answer = categoryData.map((ans) => JSONParser(ans.categoryAnswer, []));
  let csvHeaders = [];
  let csvAnswer = {};
  const { planName } = licensePlanData[0] || {};
  Answer.forEach((A) => {
    A.categoryPlaceHolder.forEach((field) => {
      csvHeaders.push({ label: field?.label, key: field.uniqueId });
      if (["select", "checkbox", "radio"].includes(field.type)) {
        let fieldValueAnswer = field.selectedAnswer;
        if (field.type === "checkbox") {
          let CheckboxAnswer = [];
          field.options.forEach((option) => {
            if (fieldValueAnswer.includes(option.value)) {
              CheckboxAnswer.push(option.value);
            }
          });
          fieldValueAnswer = CheckboxAnswer.join(",");
        } else {
          let fieldValue = field.options.find(
            (o) => o.value === field.selectedAnswer
          );
          fieldValueAnswer = !!field.selectedAnswer && fieldValue?.label;
        }
        csvAnswer[field.uniqueId] = fieldValueAnswer;
      } else {
        csvAnswer[field.uniqueId] = field.selectedAnswer;
      }
    });
  });

  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  let dogLicenseDetails = useCallback(async (e) => {
    setloading(true);
    const config = {
      method: "GET",
      url: DOG_LICENSE_DETAILS,
      // headers: authCustomerHeader(),
      params: {
        dogLicenseId: dogLicenseId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setlicenseDetails(data);
        // setReupload({
        //   validFromDate: data.validFromDate,
        //   validToDate: data.validToDate,
        //   dogLicenseNumber: data.dogLicenseNumber,
        // });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setloading(false);
    }
  }, []);

  useEffect(() => {
    dogLicenseDetails();
  }, [dogLicenseDetails]);

  let Refund = async (reson) => {
    setloading(true);
    const config = {
      method: "POST",
      url: REFUND_PAYMENT,
      data: {
        paymentDetailId: paymaentid.paymentDetailId,
        refundReason: reson,
      },
      // headers: authHeader(),
    };
    try {
      // setDeleverSpinner(true);
      const response = await API(config);
      const { status, message } = response.data;

      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
        dogLicenseDetails();
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setloading(false);
      // setDeleverSpinner(false);
    }
  };

  // let UpdateDate = () => {
  //   if (DeleteAgency) {
  //     return;
  //   }
  //   setreqNu(false);
  //   setModal(true);
  // };

  let ReuploadForm = () => {
    if (DeleteAgency) {
      return;
    }
    console.log("EDIT");
    setisEditable(false);
  };

  let sucesscallback = async () => {
    dogLicenseDetails();
    setisEditable(true);
    const conf = {
      method: "PUT",
      url: UPDATE_LICENSE_STATUS,
      data: {
        dogLicenseId: dogLicenseId,
        // licenseStatus: "Payment Completed",
        licensePlanId: licensePlanId,
      },
    };
    try {
      // const response1 = await API(conf);
      // console.log("sucess", response1);
    } catch (error) {
      console.error(error);
    }
  };

  const Cancellicense = async () => {
    if (DeleteAgency) {
      return;
    }
    Swal.fire({
      title: "Reason for Cancel",
      input: "text",
      showCancelButton: true,
      allowOutsideClick: false,
      inputPlaceholder: "Enter Reason for Cancel ",
      inputValidator: (value) => {
        if (!value) {
          return "Please enter the reason for Cancel";
        } else {
          Refund(value);
        }
      },
    });
  };

  const Showreason = (a) => {
    Swal.fire(a);
  };
  async function CreateScreenshotAndConvertPdf() {
    const emailContent = document.getElementById("capturediv");
    const canvas = await html2canvas(emailContent, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const padding = 10;
    const pageWidth = pdf.internal.pageSize.width - padding * 2;
    const pageHeight = pdf.internal.pageSize.height - padding * 2;

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const fullPages = Math.floor(imgHeight / pageHeight);
    let heightCovered = 0;
    for (let i = 0; i <= fullPages; i++) {
      const startY = (heightCovered * canvas.width) / imgWidth;
      const partHeight = Math.min(pageHeight, imgHeight - heightCovered);
      const tempCanvas = document.createElement("canvas");
      tempCanvas.width = canvas.width;
      tempCanvas.height = (partHeight * canvas.width) / imgWidth;
      const tempCtx = tempCanvas.getContext("2d");
      tempCtx.drawImage(canvas, 0, -startY);
      const partImgData = tempCanvas.toDataURL("image/png");
      pdf.addImage(partImgData, "PNG", padding, padding, imgWidth, partHeight);
      heightCovered += partHeight;
      if (i < fullPages) {
        pdf.addPage();
      }
    }
    pdf.save("Certificate.pdf");
    setTimeout(() => {
        setIsPdfDownload(false);
    }, 1000);
  }
  return (
    <div>
      <div className="agency-wrapper-without-header">
        {/* <HeaderLogo /> */}
        {(isPdfDownload || loading) && <CustomPageLoading />}
        <div id='capturediv'>
          <Container fluid="lg">
            <div>
              <div>
            <h4>
              View License{" "}
              <Tooltip
                isOpen={id === "viewlicense" && tooltipOpen}
                target={"viewlicense"}
                toggle={() => tooltiptoggle("viewlicense")}
              >
                View License
              </Tooltip>
              <span id={"viewlicense"}>
                <Info />
                </span>
                </h4>
                  <button onClick={(() => {
          setIsPdfDownload(true);
          CreateScreenshotAndConvertPdf()
        })} style={{ position: 'absolute', textAlign: 'center', right: '120px', top: "60px", padding: "10px", backgroundColor: "green", color: "white", border: "none" }}>
          Download Certificate
                  </button>
                </div>
            <h3>
              {!DeleteAgency
                ? licenseStatus !== "Rejected" &&
                  !!licenseComments && (
                    <p>
                      {" "}
                      Reason for Reject{" "}
                      <span
                        onClick={() => Showreason(licenseComments)}
                        style={{ textDecoration: "underline", color: "blue" }}
                      >
                        {" "}
                        Show More{" "}
                      </span>
                    </p>
                  )
                : ""}
            </h3>
            <h3>
              {!DeleteAgency
                ? licenseStatus === "Rejected" && (
                    <p>
                      {" "}
                      Rejected by Agency{" "}
                      <span
                        onClick={() => Showreason(licenseComments)}
                        style={{ textDecoration: "underline", color: "blue" }}
                      >
                        {" "}
                        Show More{" "}
                      </span>
                    </p>
                  )
                : ""}
            </h3>
            <div className="top-btn">
              {/* {!DeleteAgency ? (
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                  <DropdownToggle color="danger" caret>
                    Export
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <CSVLink
                        filename={`${planName}.csv`}
                        data={csvAnswers}
                        headers={csvHeaders}
                      >
                        CSV
                      </CSVLink>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              ) : (
                ""
              )} */}
              {/* <Button onClick={Back} color="primary">
                <BackButtonSvg /> Back
              </Button> */}
            </div>
          </div>

          <Card body className="mt-4 license-details">
            <div className="agency-license-view">
              <Row>
                <Col md={{ size: "auto", offset: 0 }}>
                  <h4>{planName}</h4>
                </Col>
              </Row>
            </div>

            <h5>License Details</h5>

            {/* <Row> */}
            {!isEditable ? (
              <ReuploadFormValue
                setisEditable={setisEditable}
                sucesscallback={sucesscallback}
                categoryData={categoryData}
                dogId={dogId}
                document={document1}
                Answer={Answer}
              />
            ) : (
              <AgencyPreviewform
                isEditable={isEditable}
                document={document1}
                Answer={Answer}
              />
            )}
            {/* </Row> */}
            {!DeleteAgency
              ? isEditable && (
                  <div className="centerFlexRow">
                    {licenseStatus === "Rejected" && (
                      <>
                        {" "}
                        <Button color="primary" onClick={ReuploadForm}>
                          Resubmit
                        </Button>
                        <span style={{ margin: "0 2px" }}></span>
                        <Button color="danger" onClick={Cancellicense}>
                          Cancel Order
                        </Button>
                      </>
                    )}
                  </div>
                )
              : ""}
            <h5 className="mt-5">Payment Details</h5>
            {paymentData.map((p) => (
              <Row className="license-details">
                <Col md="3">
                  <div className="info">
                    <p>{p.paymentDate}</p>
                    <span>Payment date</span>
                  </div>
                </Col>
                <Col md="3">
                  <div className="info">
                    <p>{p.planName}</p>
                    <span>Plan Name</span>
                  </div>
                </Col>
                <Col md="3">
                  <div className="info">
                    <p>{(p.totalAmount || 0).toFixed(2)}$</p>
                    <span>Paid Amount</span>
                  </div>
                </Col>
                <Col md="3">
                  <div className="info">
                    <p>
                      {" "}
                      <Badge
                        color={
                          p.paymentStatus === "Failed" ? "danger" : "success"
                        }
                      >
                        {" "}
                        {p.paymentStatus}
                      </Badge>{" "}
                    </p>
                    <span>Payment Status</span>
                  </div>
                </Col>
              </Row>
            ))}
          </Card>

          <Card body className="mt-5">
            <h5 className="mb-4">Plan Details</h5>

            <Row className="plan-list">
              {licensePlanData.map((li) => (
                <Col md="6" xl="4">
                  <div className="box">
                    <h4>{li.planName}</h4>
                    <h1>
                      <strong>$</strong>
                      {parseFloat(li.planAmount).toFixed(2)}
                    </h1>
                    <span>
                      {li.isLifeTimePlan && "Life Time Plan"}

                      {!!li.validTo && (
                        <>
                          {" "}
                          <span>Till Date</span>{" "}
                          {moment(li.validTo).format("MM-DD-YYYY")}
                        </>
                      )}
                      {!!li.planDuration && li.planDuration + "/ year"}
                    </span>
                    <p>{li.planDescription}</p>

                    <ul>
                      {li.isParkLicense ? (
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.011"
                            height="17.011"
                            viewBox="0 0 17.011 17.011"
                          >
                            <path
                              id="Icon_material-check-box"
                              data-name="Icon material-check-box"
                              d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                              transform="translate(-4.5 -4.5)"
                              fill="#fff"
                            />
                          </svg>
                          Park License
                        </li>
                      ) : (
                        ""
                      )}

                      {li.isKennelLicense && (
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.011"
                            height="17.011"
                            viewBox="0 0 17.011 17.011"
                          >
                            <path
                              id="Icon_material-check-box"
                              data-name="Icon material-check-box"
                              d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                              transform="translate(-4.5 -4.5)"
                              fill="#fff"
                            />
                          </svg>
                          Kennel License
                        </li>
                      )}

                      {li.isDogLicense && (
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.011"
                            height="17.011"
                            viewBox="0 0 17.011 17.011"
                          >
                            <path
                              id="Icon_material-check-box"
                              data-name="Icon material-check-box"
                              d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                              transform="translate(-4.5 -4.5)"
                              fill="#fff"
                            />
                          </svg>
                          Dog License
                        </li>
                      )}

                      {li.isRenewal && (
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.011"
                            height="17.011"
                            viewBox="0 0 17.011 17.011"
                          >
                            <path
                              id="Icon_material-check-box"
                              data-name="Icon material-check-box"
                              d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                              transform="translate(-4.5 -4.5)"
                              fill="#fff"
                            />
                          </svg>
                          Renewal
                        </li>
                      )}
                    </ul>
                  </div>
                </Col>
              ))}
            </Row>
          </Card>
        </Container>
        </div>
      </div>
    </div>
  );
}

export default Userviewlicense;
